import { TreatArches } from 'app/core/domain/PrimaryCasePreferences'

const ArchesToTreatDataTestIdMap: { [key: string]: string } = {
  [TreatArches.BOTH]: 'ArchesToTreat-Both',
  [TreatArches.UPPER_ONLY]: 'ArchesToTreat-UpperOnly',
  [TreatArches.LOWER_ONLY]: 'ArchesToTreat-LowerOnly',
} as const

export { ArchesToTreatDataTestIdMap }
